module.exports = __webpack_public_path__ + "static/img/man.8ee12537.jpg";